export default __webpack_public_path__ + "static/media/751.ba233cff.png";